import React from "react";
import closeIcon from "../../Icons/close-small.svg";
import "./style.css";
export interface ReferralModalProp {
  onClose: () => void;
  referredUsers: any;
}
const ReferralModal: React.FC<ReferralModalProp> = ({
  onClose,
  referredUsers,
}) => {
  return (
    <div
      className="backdrop-blur-[20px] backdrop-filter bg-[rgba(255,255,255,0.72)] box-border content-stretch flex flex-col gap-2 h-[100vh] items-start justify-start p-[56px] relative rounded-tl-[24px] rounded-bl-[24px] shadow-[-4px_0px_24px_0px_rgba(0,0,0,0.02)] shrink-0"
      data-name="Create Workspace Modal"
    >
      <div className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-0 relative shrink-0 w-[400px] h-full  confirmation-content">
        <div className="box-border content-stretch flex flex-row gap-6 items-center justify-center p-0 relative shrink-0 w-full">
          <div className="basis-0 font-['Geist:Medium',_sans-serif] font-medium grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[24px] text-left tracking-[-0.24px]">
            <p className="block leading-[30px]">My referrals</p>
          </div>
          <img
            className="w-[24px] cursor-pointer"
            src={closeIcon}
            onClick={() => {
              onClose();
            }}
          />
        </div>

        <div className="refered-list">
          {referredUsers && referredUsers.length > 0 ? (
            <>
              {referredUsers.map((user: any, idx) => {
                return (
                  <div className="list-tab" key={idx}>
                    <div className="email">{user.email || "-"}</div>
                  </div>
                );
              })}
            </>
          ) : (
            <div className="empty-state">No Referred users</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferralModal;
